import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const adminRetrieveTeacherLessons = createAsyncThunk<TeacherLessonListVM[], string, { extra: Partial<Dependencies> }>(
  "lessons/adminRetrieveTeacherLessons",
  async (teacherId: string, { extra: { adminRepository } }) => {
    return adminRepository!.teacherLessons(teacherId);
  },
);
